module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('table', {
    staticClass: "pricing-table"
  }, [_vm._m(0), _vm._v(" "), _c('draggable', {
    attrs: {
      "list": _vm.part.content,
      "element": "tbody"
    }
  }, _vm._l((_vm.part.content), function(row, index) {
    return (_vm.part && _vm.part.content) ? _c('tr', {
      key: index,
      staticClass: "tr"
    }, [(row.type === 'section-divider') ? [_c('td', {
      staticClass: "section-divider",
      attrs: {
        "colspan": "4"
      }
    }, [_c('pricing-table-textarea', {
      attrs: {
        "state": _vm.state
      },
      model: {
        value: (row.data.title),
        callback: function($$v) {
          _vm.$set(row.data, "title", $$v)
        },
        expression: "row.data.title"
      }
    }), _vm._v(" "), (_vm.state === 'editor') ? _c('span', {
      staticClass: "delete-row",
      on: {
        "click": function($event) {
          _vm.deleteRow(index)
        }
      }
    }, [_c('i', {
      staticClass: "icon icon-trash"
    })]) : _vm._e()], 1)] : _vm._e(), _vm._v(" "), (row.type === 'data') ? [_c('td', {
      staticClass: "name"
    }, [_c('pricing-table-textarea', {
      attrs: {
        "state": _vm.state
      },
      model: {
        value: (row.data.name),
        callback: function($$v) {
          _vm.$set(row.data, "name", $$v)
        },
        expression: "row.data.name"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "quantity"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (row.data.quantity),
        expression: "row.data.quantity"
      }],
      attrs: {
        "type": "text",
        "readonly": _vm.state !== 'editor'
      },
      domProps: {
        "value": (row.data.quantity)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(row.data, "quantity", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "price"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (row.data.price),
        expression: "row.data.price"
      }],
      attrs: {
        "type": "text",
        "readonly": _vm.state !== 'editor'
      },
      domProps: {
        "value": (row.data.price)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(row.data, "price", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "subtotal"
    }, [_vm._v("\n              " + _vm._s(_vm._f("currency")(row.data.quantity * row.data.price)) + "\n              "), (_vm.state === 'editor') ? _c('span', {
      staticClass: "delete-row",
      on: {
        "click": function($event) {
          _vm.deleteRow(index)
        }
      }
    }, [_c('i', {
      staticClass: "icon icon-trash"
    })]) : _vm._e()])] : _vm._e()], 2) : _vm._e()
  })), _vm._v(" "), _c('tfoot', [_c('tr', {
    staticClass: "subtotal"
  }, [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_c('strong', [_vm._v("Subtotal:")]), _vm._v(" " + _vm._s(_vm._f("currency")(_vm.subtotal)))])]), _vm._v(" "), _c('tr', {
    staticClass: "total"
  }, [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_c('strong', [_vm._v("Total:")]), _vm._v(" " + _vm._s(_vm._f("currency")(_vm.total)))])])])], 1), _vm._v(" "), (_vm.state === 'editor') ? _c('button', {
    staticClass: "button is-primary is-small add-row",
    on: {
      "click": function($event) {
        _vm.addRow()
      }
    }
  }, [_vm._v("Add Row")]) : _vm._e(), _vm._v(" "), (_vm.state === 'editor') ? _c('button', {
    staticClass: "button is-primary is-small add-section",
    on: {
      "click": function($event) {
        _vm.addSection()
      }
    }
  }, [_vm._v("Add Section")]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Quantity")]), _vm._v(" "), _c('th', [_vm._v("Price")]), _vm._v(" "), _c('th', [_vm._v("Subtotal")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c580d06","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/document-parts/pricing-table.vue
// module id = 517
// module chunks = 0